/* eslint-disable react/destructuring-assignment */
import { Icon, IconCheck, IconEdit, IconQuestionMark, IconX } from '@tabler/icons-react';

export enum ProposalTypeEnum {
  Completa = 'CO',
  Reajuste = 'RE',
}

export enum ProposalStatusEnum {
  EmEdicao = 'EE',
  Cancelado = 'CA',
  Finalizado = 'FI',
}

const map = [
  {
    currentStatus: ProposalStatusEnum.EmEdicao,
    validStatuses: [ProposalStatusEnum.Cancelado, ProposalStatusEnum.Finalizado],
  },
  {
    currentStatus: ProposalStatusEnum.Cancelado,
    validStatuses: [],
  },
  {
    currentStatus: ProposalStatusEnum.Finalizado,
    validStatuses: [],
  },
];

const getValidStatuses = (currentStatusCode: ProposalStatusEnum): ProposalStatusEnum[] => {
  return map.find((x) => x.currentStatus === currentStatusCode)?.validStatuses || [];
};

const getStatusAction = (currentStatusCode: ProposalStatusEnum): { action: string; icon: Icon } => {
  switch (currentStatusCode) {
    case ProposalStatusEnum.EmEdicao:
      return { action: 'Editar', icon: IconEdit };
    case ProposalStatusEnum.Cancelado:
      return { action: 'Cancelar', icon: IconX };
    case ProposalStatusEnum.Finalizado:
      return { action: 'Finalizar', icon: IconCheck };
    default:
      return { action: '?', icon: IconQuestionMark };
  }
};

const validarStatusWorkflow = (newStatusCode: ProposalStatusEnum, currentStatusCode: ProposalStatusEnum) => {
  if (
    map
      .find((x) => x.currentStatus === currentStatusCode)
      ?.validStatuses.findIndex((y) => y === newStatusCode) === -1
  ) {
    throw Error('Não é possível atualizar essa proposta com esse novo status.');
  }
};

export { getStatusAction, getValidStatuses, validarStatusWorkflow };
